import { Component, Input, OnInit } from '@angular/core';

import { ViewCell } from 'ng2-smart-table';
import { NbToastrService } from '@nebular/theme';
import { plainToClass } from 'class-transformer';
import { User } from '../../shared/data/user';
import { Config } from '../../config/config';


@Component({
  template: `
    <nb-actions size="small">
      <nb-action class="user-action" >
        <nb-user
          
                [onlyPicture]="userPictureOnly"
                [name]="user.username"
                [picture]="(user.photo !== null) ? this.user.photo.url : ''">
        </nb-user>
      </nb-action>
    </nb-actions>
  `,
})
export class ProfilRenderComponent implements ViewCell, OnInit {

  renderValue: string;

  @Input() value: string;
  @Input() rowData: any;

  urlapi = Config.urlserveur;

  userPictureOnly: boolean = false;

  user: User;

  constructor( public toastr:NbToastrService) {

  }

  ngOnInit() {
    // this.renderValue = this.value.toString().toUpperCase();
    //this.renderValue = this.value;
    this.user = plainToClass( User, this.rowData as object);

    
  }

}
